module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/PL-683690061d0bf3c396e70a8e21929203.png";